import { FormItemProps as ANTFormItemProps, Form } from 'antd';
import React, { FC, PropsWithChildren, useMemo } from 'react';

import { JLabel } from '../../JForm/JLabel';
import { ComposedTranslationLabelsOptions, isJDateField, JFieldBaseProps } from '../models';
import { isFieldType } from '../utils';
import { getValidationLabels, getValidators } from './../validators';
import { useCompositorContext } from './CompositorProvider';
import {InfoCircleOutlined} from "@ant-design/icons";
import {useJCommonContext} from "../../JCommonProvider";
import {Rule} from "antd/lib/form";


export function withFormItem<T extends JFieldBaseProps>(Component: FC<T>) {

    const WithFormItem: FC<T> = props => (
        <FormItem fieldProps={props}>
            <Component {...props} />
        </FormItem>
    )

    return WithFormItem
}

export interface FormItemProps extends ANTFormItemProps {
    validatorOptions?: ComposedTranslationLabelsOptions
    fieldProps: JFieldBaseProps
}
export const FormItem: FC<PropsWithChildren<FormItemProps>> = ({ fieldProps, validatorOptions, ...props }) => {
    const { translate } = useCompositorContext();
    const {getImageURL} = useJCommonContext();
    const translateLabels = useMemo(() => getValidationLabels(fieldProps.label, translate, {
        validationMessage: fieldProps.validationMessage,
        ignoreConfirm: validatorOptions?.ignoreConfirm ?? true,
        ignoreNoMatch: validatorOptions?.ignoreNoMatch ?? true,
        ignoreRequired: validatorOptions?.ignoreRequired ?? !fieldProps.mandatory,
        ignoreInvalidDate: !isJDateField(fieldProps),
        ignoreInvalidPhone: !isFieldType.PHONE(fieldProps.type)
    }), [fieldProps])

    const fieldValidators = useMemo(() => getValidators(fieldProps, translateLabels), [fieldProps])
    let rules: Rule[] =  useMemo(() =>  fieldValidators.concat(props.rules || []), []);

    //if overrideValue is not null, we want to remove the rules
    if(!!fieldProps?.overrideValue){
        rules = []
    }

    const label = fieldProps.showLabel && fieldProps.label && <JLabel label={fieldProps.label} />
    const tooltip = fieldProps.tooltip?.title  && {
        title: fieldProps.tooltip?.title,
        icon: (fieldProps?.tooltip?.icon ? <img aria-hidden={true} src={getImageURL(fieldProps?.tooltip?.icon)} alt={fieldProps?.tooltip?.title ?? ''}/> : <InfoCircleOutlined aria-hidden={true}/> )
    }
    const className = `${fieldProps.hidden ? 'hidden' : 'visible'} hurlId-${fieldProps.fieldKey} field-name-${fieldProps.name.join('-')} field-type-${fieldProps.type.toLocaleLowerCase()}`
    return (
        <Form.Item
            {...props}
            className={`${className} ${props.className || ''}`}
            name={props.name || fieldProps.name}
            initialValue={props.initialValue || fieldProps.value}
            labelCol={{ span: 24 }}
            label={label}
            tooltip={tooltip}
            rules={rules}
            aria-describedby={translateLabels.required || translateLabels.wrongFormat}
        >
            {
                props.children
            }
        </Form.Item>
    )
}
